import axios from "axios";
import dayjs from "dayjs";
import { useEffect } from "react";
import { request } from "../../utils/request";

const POLL_INTERVAL_MS = 5 * 60 * 1000;
// Dung khoang mo (khong dat can duoi hep) de khong bo lot moc nhac:
// - 24h: con >2h va <=24h, chua gui -> gui (bat ke luc xac nhan da duoi 24h san)
// - 2h: con >0 va <=2h, chua gui -> gui
// Chi dua vao co da_gui_nhac_* de chong gui trung, khong dua vao khoang thoi
// gian hep nen khong the "bo lo" mot moc chi vi quet tre hoac xac nhan muon.
const MOC_24H_PHUT = 24 * 60;
const MOC_2H_PHUT = 2 * 60;

const TAB_ID = Math.random().toString(36).slice(2);
const LOCK_KEY = "booking_reminder_poller_lock";
const LOCK_TTL_MS = 6 * 60 * 1000;

// Khoa don gian bang localStorage: neu nhieu tab CRM cung mo tren 1 may,
// chi tab nao dang giu khoa con hieu luc moi duoc quet - tranh gui trung.
function tryAcquireLock() {
	try {
		const raw = localStorage.getItem(LOCK_KEY);
		const now = Date.now();
		if (raw) {
			const { tabId, ts } = JSON.parse(raw);
			if (tabId !== TAB_ID && now - ts < LOCK_TTL_MS) {
				return false;
			}
		}
		localStorage.setItem(
			LOCK_KEY,
			JSON.stringify({ tabId: TAB_ID, ts: now }),
		);
		return true;
	} catch (e) {
		return true;
	}
}

const fetchLinkWebhook = async (idApp, token) => {
	try {
		const res = await request.get("api/app", {
			params: {
				q: JSON.stringify({ _id: idApp }),
				notfields: "__v",
			},
			headers: {
				"X-Access-Token": token,
				"Content-Type": "application/json",
			},
		});
		return res?.data?.[0]?.exfields?.link_webhook || null;
	} catch (e) {
		console.error("Khong lay duoc link_webhook", e);
		return null;
	}
};

const guiNhacLich = async ({
	item,
	flagField,
	linkWebhook,
	idApp,
	token,
}) => {
	try {
		await axios.post(
			linkWebhook,
			{
				booking_id: item?._id,
				booking_code: item?.exfields?.ma_lich_hen,
				customer_name: `${item?.exfields?.ho_ten_dem || ""} ${
					item?.ten_kh || ""
				}`.trim(),
				phone: item?.dien_thoai,
				appointment_at: item?.exfields?.thoi_gian_hen,
				appointment_status: item?.exfields?.trang_thai_hen,
			},
			{ headers: { "Content-Type": "application/json" } },
		);
		await request.put(
			`api/${idApp}/so1/${item?._id}`,
			{
				...item,
				exfields: { ...item?.exfields, [flagField]: true },
			},
			{
				headers: {
					"X-Access-Token": token,
					"Content-Type": "application/json",
				},
			},
		);
	} catch (e) {
		console.error("Gui nhac lich loi", item?._id, e);
	}
};

export default function BookingReminderPoller() {
	useEffect(() => {
		let cancelled = false;

		const tick = async () => {
			const token = localStorage.getItem("token");
			const idApp = localStorage.getItem("id_app");
			if (!token || !idApp) return;
			if (!tryAcquireLock()) return;

			const linkWebhook = await fetchLinkWebhook(idApp, token);
			if (!linkWebhook) return;

			try {
				const res = await request.get(`api/${idApp}/so1`, {
					params: {
						q: JSON.stringify({ trang_thai: 1 }),
						limit: 200,
					},
					headers: {
						"X-Access-Token": token,
						"Content-Type": "application/json",
					},
				});
				const now = dayjs();
				for (const item of res?.data || []) {
					if (cancelled) return;
					const hen = dayjs(item?.exfields?.thoi_gian_hen);
					if (!hen.isValid()) continue;
					const diffMin = hen.diff(now, "minute");

					if (
						!item?.exfields?.da_gui_nhac_24h &&
						diffMin > MOC_2H_PHUT &&
						diffMin <= MOC_24H_PHUT
					) {
						await guiNhacLich({
							item,
							flagField: "da_gui_nhac_24h",
							linkWebhook,
							idApp,
							token,
						});
					}
					if (
						!item?.exfields?.da_gui_nhac_2h &&
						diffMin > 0 &&
						diffMin <= MOC_2H_PHUT
					) {
						await guiNhacLich({
							item,
							flagField: "da_gui_nhac_2h",
							linkWebhook,
							idApp,
							token,
						});
					}
				}
			} catch (e) {
				console.error("Quet nhac lich hen loi", e);
			}
		};

		tick();
		const intervalId = setInterval(tick, POLL_INTERVAL_MS);
		return () => {
			cancelled = true;
			clearInterval(intervalId);
		};
	}, []);

	return null;
}
